import React from "react";
// import { MdOutlineDateRange } from "react-icons/md";
// import BookNowCard from "./BookNowCard";

const Itinary = ({ itinary }: { itinary: string }) => {
  return (
    <div>
      <h1 className="text-2xl font-semibold mt-16 text-primary-base">
        Tour Itinary
      </h1>
      <div className="prose lg:prose-lg 2xl:prose-xl lg:prose-h1:leading-normal prose-p:text-justify prose-p:leading-loose  w-full max-w-full">
        <div
          className="col-span-8"
          dangerouslySetInnerHTML={{ __html: itinary }}
        ></div>
      </div>
    </div>
  );
};

export default Itinary;
